import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { toDollar } from '../../../utils/dataConverter';
import { TaxCalculations } from "../../../model/tax_calculations";

export default function CreditBreakdownCard({ calculations }: { calculations: TaxCalculations }) {

  return (
    <Card className='card-root'>
      <CardContent>
        <Typography component={'h2'} className='title'>Your Credits</Typography>
        <p className='description'>
          Here are all the credits on your account; we’ll subtract these credits
          from your tax to come up with a final balance due.
        </p>
        <Box className='options'>
          <Typography className='subtitle'>Springboro Tax Withheld</Typography>
          <Typography className='sub-value'>{ toDollar(calculations.credit_for_springboro_tax_withheld) }</Typography>
        </Box>
        <Grid container className='card-root' spacing={0}>
          <Grid
            sx={{ paddingRight: '1.2rem' }}
            size={{
              xs: 4,
              md: 5,
              lg: 2
            }}>
            <Box className='options'>
              <Typography className='subtitle'>Taxpayer Credits</Typography>
              <Typography className='sub-value'>{ toDollar(calculations.taxpayer_credits) }</Typography>
            </Box>
          </Grid>
          <Grid
            className='highlight'
            size={{
              xs: 8,
              md: 7,
              lg: 10
            }}>
            <p className='highlight-text'>These include any estimated payments and carryover credits</p>
          </Grid>
        </Grid>
        <Grid container className='card-root' spacing={0}>
          <Grid
            sx={{ paddingRight: '1.2rem' }}
            size={{
              xs: 4,
              md: 5,
              lg: 2
            }}>
            <Box className='options'>
              <Typography className='subtitle'>Credit for Other City Withholding</Typography>
              <Typography className='sub-value'>{ toDollar(calculations.credit_for_other_city_tax_withheld) }</Typography>
            </Box>
          </Grid>
          <Grid
            className='highlight'
            size={{
              xs: 8,
              md: 7,
              lg: 10
            }}>
            <span className='highlight-text'>This credit is limited to the lesser of:</span>
            <ul className='highlight-text'>
              <li>1% of the wages taxed by other cities, or</li>
              <li>The actual amount of tax withheld</li>
            </ul>
          </Grid>
        </Grid>
        
        <Box className='options'>
          <Typography className='subtitle'>Total Credits</Typography>
          <Typography className='sub-value sub-value-bold'>{ toDollar(calculations.total_credits) }</Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
